import { endpoint, API_BASE_URL, INVITE_API_ENDPOINTS } from '@/utils/api/endpoints';
import axios from 'axios';
// import { email } from 'vuelidate/lib/validators';

export default {
	namespaced: true,

	actions: {
		async InviteNewUser({ commit }, { data }) {
			console.log(commit);
			console.log(data);

			if (!data) throw window.$Error(window.$ERROR.ERR_MISSING_ARG, { parent: 'Argument not provided' });
			try {
				const url = endpoint(API_BASE_URL, INVITE_API_ENDPOINTS.INVITE);
				const results = await axios.post(url, data).catch(error => {
					console.error('Error during POST request:', error);
					throw error; // Rethrow the error to propagate it up the call stack
				});

				if (!results) throw window.$Error(window.$ERROR.ERR_REQUEST_FAILED, { parent: 'Failed to send invite' });

				return results.data;
			} catch (err) {
				throw window.$Error(window.$ERROR.ERR_REQUEST_FAILED, { parent: err });
			}
		},
	},
};
